import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-branch-pipe",
  "use": "icon-branch-pipe-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-branch-pipe\">\r\n  <path d=\"M2 12h8M2 8h6M2 4h4M10 12h2M8 8h4M6 4h8\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" fill=\"none\" />\r\n  <circle cx=\"12\" cy=\"12\" r=\"1\" fill=\"currentColor\" />\r\n  <circle cx=\"10\" cy=\"8\" r=\"1\" fill=\"currentColor\" />\r\n  <circle cx=\"8\" cy=\"4\" r=\"1\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol